import React from 'react';
import { Link } from 'react-router-dom';

const CAL_URL = 'https://calendly.com/thecollinsacademynew/30min';

const Header = () => {
  return (
    <header className="tcf-header" data-testid="tcf-header">
      <div className="tcf-header-inner">
        <Link to="/" className="tcf-header-logo" data-testid="header-logo" aria-label="The Collins Academy">
          <img
            src="/logo.png"
            alt="The Collins Academy"
            width="240"
            height="60"
          />
        </Link>
        <a
          href={CAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="tcf-header-cta"
          data-testid="header-cta"
        >
          Book a Call
        </a>
      </div>
    </header>
  );
};

export default Header;
